import React from 'react';

import PendenciesContainer from '~/screens/ContractDetails/Panels/Pendencies/PendenciesContainer';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractPendenciesViewProps = {
  contractId: string;
  onBack: () => void;
};

export function ContractPendenciesView({ contractId, onBack }: ContractPendenciesViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <PendenciesContainer contractId={Number(contractId)} />
    </div>
  );
}
